import { LayerInfo } from "../../../interfaces/resourceInfo";

export const getRelatedAttribute = (layerInfo: LayerInfo, sourceAttributeName: string, relatedLayerName: string) => {
  const attributeConfig = layerInfo?.configuration?.cardConfiguration?.children?.find(
    ({ attributeName }) => attributeName === sourceAttributeName,
  );

  return attributeConfig?.options?.relatedAttributes?.find(({ layerName }) => layerName === relatedLayerName);
};
